document.addEventListener('DOMContentLoaded', () => {
  let form = document.querySelector('#blog-search');
  if (form) {
    let params = new URLSearchParams(window.location.search);
    if (params.get('keyword'))
      form.querySelector('#search-keyword').value = params.get('keyword');
    if (params.get('category'))
      form.querySelector('#search-category').value = params.get('category');
  }
})
